import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SubHeader from "components/SubHeader";
import { ROUTES } from "shared/constants/routes";
import { fetchCart } from "actions/dtfCart";
import CartItemCard from "pages/dtf-transfers/cart/CartItemCard";
import CartSidebar from "pages/dtf-transfers/cart/CartSidebar";
import ContinueShoppingButton from "pages/dtf-transfers/checkout/ContinueShoppingButton";
import {
  Container,
  CartLayout,
  CartMain,
  CartPageTitle,
  CartPageSubtitle,
  EmptyCartMessage,
  EmptyCartCard,
} from "styles/pages/dtf-transfers/cart";

const DtfCart = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const cartItems = useSelector((state) => state?.dtfCart?.items || []);
  const cartCount = useSelector((state) => {
    const cart = state?.dtfCart;
    return cart?.count ?? cart?.items?.length ?? 0;
  });
  const isCartLoading = useSelector((state) => state?.dtfCart?.loading);
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const token = useSelector((state) => state?.auth?.profile?.token);

  const subtotal = cartItems.reduce((sum, item) => sum + (item.total || 0), 0);

  useEffect(() => {
    if (emailid && location.pathname === ROUTES.DTF_TRANSFERS_CART.LINK) {
      dispatch(fetchCart(emailid, token));
    }
  }, [dispatch, emailid, token, location.pathname]);

  return (
    <Container>
      <SubHeader
        title={ROUTES.DTF_TRANSFERS_CART.TITLE}
        links={[
          {
            title: ROUTES.HOME.TITLE,
            to: ROUTES.HOME.LINK,
          },
          {
            title: ROUTES.DTF_TRANSFERS.TITLE,
            to: ROUTES.DTF_TRANSFERS_BY_SIZE.LINK,
          },
        ]}
        currentPageTitle={ROUTES.DTF_TRANSFERS_CART.TITLE}
      />

      {isCartLoading ? (
        <EmptyCartCard>
          <EmptyCartMessage>Loading cart...</EmptyCartMessage>
          <ContinueShoppingButton />
        </EmptyCartCard>
      ) : cartItems.length ? (
        <CartLayout>
          <CartMain>
            <div>
              <CartPageTitle>
                Shopping Cart ({cartCount} item{cartCount === 1 ? "" : "s"})
              </CartPageTitle>
              <CartPageSubtitle>DTF TRANSFERS</CartPageSubtitle>
            </div>

            {cartItems.map((item, index) => (
              <CartItemCard key={item.id ?? index} item={item} />
            ))}
          </CartMain>

          <CartSidebar subtotal={subtotal} cartItems={cartItems} />
        </CartLayout>
      ) : (
        <EmptyCartCard>
          <EmptyCartMessage>Your cart is empty.</EmptyCartMessage>
          <ContinueShoppingButton />
        </EmptyCartCard>
      )}
    </Container>
  );
};

export default DtfCart;
